import { render } from "./garage-vehicle-details.vue?vue&type=template&id=dd284280"
import script from "./garage-vehicle-details.vue?vue&type=script&lang=js"
export * from "./garage-vehicle-details.vue?vue&type=script&lang=js"

import "./garage-vehicle-details.vue?vue&type=style&index=0&id=dd284280&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__